<template>
  <b-container fluid id="start-container">
    <v-stepper v-model="e1">
      <v-stepper-header>
        <b-row class="stepper-row">
          <b-col cols="11">
            <b-row>
              <v-stepper-step :editable="e1 > 3" :complete="e1 > 3" step="3"
                ><span>{{ $t("landing.auth") }}</span></v-stepper-step
              >
              <v-stepper-step :editable="e1 > 4" :complete="e1 > 4" step="4"
                ><span>{{ $t("landing.topics") }}</span></v-stepper-step
              >
              <v-stepper-step :editable="e1 > 5" :complete="e1 > 5" step="5"
                ><span>{{ $t("landing.courses") }}</span></v-stepper-step
              >
              <v-stepper-step :editable="e1 > 9" :complete="e1 > 9" :step="optionstep"
                ><span>{{ $t("landing.options") }}</span></v-stepper-step
              >
              <v-stepper-step :editable="e1 > 10" :complete="e1 > 10" step="10"
                ><span>{{ $t("landing.present") }}</span></v-stepper-step
              >
            </b-row>
          </b-col>
          <b cols="1">
            <img v-if="internet == 'on'" class="internet-logo" src="../assets/on.svg" alt="internet" />
            <img v-if="internet == 'off'" class="internet-logo" src="../assets/off.svg" alt="internet" />
          </b>
        </b-row>
      </v-stepper-header>

      <v-stepper-items class="wrapper rebate-wrapper">
        <v-stepper-content step="2">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row">
              <b-col cols="12" sm="12">
                <h2 class="rebate-header">
                  <img class="header-icon" src="../assets/login.svg" alt="Login" />
                  {{ $t("landing.pin") }}
                </h2>
                <br />
                <span class="error-login" v-if="pinerror">{{ pinerrorMsg }}</span>
                <b-form-group class="form-element" label-cols="12" label-cols-md="5" label-size="md" label-for="number">
                  <b-form-input size="lg" class="rebate-lg-input" v-model="userPin" @keyup.enter.native="step2" type="password" name="userPin"></b-form-input>
                  <div v-if="$v.userPin.$error">
                    <b-form-invalid-feedback v-if="!$v.userPin.required">{{ $t("rebate.requiredfield") }}</b-form-invalid-feedback>
                  </div>
                </b-form-group>
              </b-col>
              <b-button type="submit" tabindex="0" @click="step2" class="mmm-button next intro"
                >{{ $t("landing.beginbutton") }}
                <hr class="mmm-bar main-gradient" />
                <hr class="white-bar" />
              </b-button>
            </b-row>
          </v-card>
        </v-stepper-content>

        <!-- Welcome Back and Activation Dates -->
        <v-stepper-content step="3">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row">
              <b-col cols="12" sm="11">
                <h2 class="rebate-header">
                  <img class="header-icon" src="../assets/credential.svg" alt="Credentials" />
                  {{ $t("landing.welcome") }}, {{ instructorData.name }}
                </h2>

                <b-row no-gutters class="mt-5 mb-4">
                  <b-col cols="12" sm="6">
                    <h3>{{ $t("landing.certexpiry") }}:</h3>
                    <p class="date">
                      <strong v-if="instructorData.certexpiry">{{ instructorData.certexpiry | moment("MMMM Do YYYY") }}</strong>
                    </p>
                    <p class="pr-4">{{ $t("landing.certexpirydesc") }}</p>
                  </b-col>

                  <b-col cols="12" sm="6">
                    <h3>{{ $t("landing.offexpiry") }}:</h3>
                    <p class="date">
                      <strong v-if="this.expiry">{{ this.expiry | moment("MMMM Do YYYY") }}</strong>
                    </p>
                    <p>{{ $t("landing.offexpirydesc") }}</p>
                  </b-col>

                  <b-col class="mt-4" cols="12" v-if="updatecheck">
                    <h3><strong>Updates Available</strong></h3>
                    <p>Please note that you have one or more presentations that have an available update. To update, go to manage my presentations.</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <div class="button-cont mb-3">
              <b-button type="submit" tabindex="0" v-if="showmanage" @click="reroute" class="mmm-button next intro"
                >Manage your presentations
                <hr class="mmm-bar main-gradient" />
                <hr class="white-bar" />
              </b-button>

              <b-button type="submit" tabindex="0" v-if="showskip" @click="step3" class="mmm-button next blacked intro"
                >{{ $t("landing.beginbutton") }}
                <hr class="mmm-bar main-gradient" />
                <hr class="white-bar blacked" />
              </b-button>
            </div>
          </v-card>
        </v-stepper-content>

        <!-- Course Topics -->
        <v-stepper-content step="4">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row">
              <b-col cols="12" sm="10">
                <!-- <p>{{ instructor.storedcert }}</p> -->
                <h2 v-if="instructor.certifications" class="rebate-header">{{ $t("landing.selectcourse") }}</h2>
                <!-- <h2 v-if='Object.keys(instructor.certifications).length === 0' class="rebate-header">There is currently no Safety Training courses available.</h2>
                <p v-if='Object.keys(instructor.certifications).length === 0' >Please contact 3M Safety Training for support.</p> -->

                <b-row class="mt-2 mb-2" no-gutters>
                  <b-col class="mt-2 mb-2" cols="12" sm="6" v-for="topic in instructorData.storedcert" v-bind:key="topic.id" v-bind:value="topic.id" v-if="topic.available">
                    <!-- <p>{{ topic }}</p> -->
                    <b-row @click="step4(topic)" no-gutters align-v="center" class="button">
                      <b-col cols="4"><img class="topicicon" :src="getImgUrlExternal(topic.icon, 'topics')" :alt="topic.name" /></b-col>
                      <b-col cols="8"
                        ><p class="topicname">{{ topic.name }}</p></b-col
                      >
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </v-card>
        </v-stepper-content>

        <!-- Courses -->
        <v-stepper-content step="5">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row">
              <b-col cols="12" sm="12">
                <h2 class="rebate-header">{{ current.topic.name }}</h2>

                <b-row class="mt-2 mb-2" no-gutters>
                  <b-col class="mt-2 mb-2" cols="12" sm="6" md="3" v-for="course in current.topic.courses" :key="course.id" :value="course.id" v-if="course.available">
                    <b-row no-gutters @click="step5(course)" align-v="center" class="button">
                      <b-col>
                        <img class="courseicon fluid" v-if="course.icon" :src="getImgUrlExternal(course.icon, 'courses')" :alt="course.name" /><br />
                        <p class="coursename">{{ course.name }}</p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </v-card>
        </v-stepper-content>

        <!-- Location Country -->
        <v-stepper-content step="6">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row" v-if="current.course">
              <b-col class="selectedcourse" cols="12" sm="4">
                <b-row no-gutters>
                  <img class="courseicon" fluid :src="getImgUrlExternal(current.course.icon, 'courses')" :alt="current.course.name" />
                  <h2>{{ current.topic.name }} – {{ current.course.name }}</h2>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" offset-sm="1" class="dayselection">
                <p class="description">{{ $t("landing.choosecountry") }}</p>

                <b-form-select v-model="selected.country" :options="countries" size="lg" class="mb-3"></b-form-select>

                <b-button type="submit" tabindex="0" @click="step6" :disabled="!selected.country ? '' : false" class="mmm-button next"
                  >{{ $t("landing.beginbutton") }}
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar" />
                </b-button>
              </b-col>
            </b-row>
          </v-card>
        </v-stepper-content>

        <!-- Location Province -->
        <v-stepper-content step="7">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row" v-if="current.course">
              <b-col class="selectedcourse" cols="12" sm="4">
                <b-row no-gutters>
                  <img class="courseicon" fluid :src="getImgUrlExternal(current.course.icon, 'courses')" :alt="current.course.name" />
                  <h2>{{ current.topic.name }} – {{ current.course.name }}</h2>
                  <div class="currentselections">
                    <p class="selectallcap">Country: {{ selected.country }}</p>
                  </div>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" offset-sm="1" class="dayselection">
                <p class="description">{{ $t("landing.chooseprovince") }}</p>

                <b-form-select v-model="province" :options="provinces" size="lg"></b-form-select>

                <b-button type="submit" tabindex="0" @click="step7" :disabled="!province ? '' : false" class="mmm-button next dropdown"
                  >{{ $t("landing.beginbutton") }}
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar" />
                </b-button>
              </b-col>
            </b-row>
          </v-card>
        </v-stepper-content>

        <!-- Training Day -->
        <v-stepper-content step="8">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row" v-if="current.course">
              <b-col class="selectedcourse" cols="12" sm="4">
                <b-row no-gutters>
                  <img class="courseicon" fluid :src="getImgUrlExternal(current.course.icon, 'courses')" :alt="current.course.name" />
                  <h2>{{ current.topic.name }} – {{ current.course.name }}</h2>
                  <div class="currentselections">
                    <p class="selectallcap">Country: {{ selected.country }}</p>
                    <p v-if="selected.state" class="selectallcap">Province: {{ selected.state }}</p>
                  </div>
                </b-row>
              </b-col>

              <b-col cols="12" sm="6" offset-sm="1" class="dayselection">
                <p class="description">{{ $t("landing.trainingday") }}</p>

                <b-form-select v-model="selected.day" :options="daycount" size="lg" class="mb-3"></b-form-select>

                <b-button type="submit" tabindex="0" @click="step8" :disabled="!selected.day ? '' : false" class="mmm-button next"
                  >{{ $t("landing.beginbutton") }}
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar" />
                </b-button>
              </b-col>
            </b-row>
          </v-card>
        </v-stepper-content>

        <!-- Language -->
        <v-stepper-content step="9">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row" v-if="current.course">
              <b-col class="selectedcourse" cols="12" sm="4">
                <b-row no-gutters>
                  <img class="courseicon" fluid :src="getImgUrlExternal(current.course.icon, 'courses')" :alt="current.course.name" />
                  <h2>{{ current.topic.name }} – {{ current.course.name }}</h2>
                  <div class="currentselections">
                    <p class="selectallcap">Country: {{ selected.country }}</p>
                    <p v-if="selected.state" class="selectallcap">Province: {{ selected.state }}</p>
                    <p class="selectallcap">Day: {{ selected.day }}</p>
                  </div>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" offset-sm="1" class="dayselection">
                <p class="description">{{ $t("landing.chooselanguage") }}</p>

                <b-form-select v-model="language" :options="languages" size="lg"></b-form-select>

                <b-button type="submit" tabindex="0" @click="step9" :disabled="!language ? '' : false" class="mmm-button next dropdown"
                  >{{ $t("landing.beginbutton") }}
                  <hr class="mmm-bar main-gradient" />
                  <hr class="white-bar" />
                </b-button>
              </b-col>
            </b-row>
          </v-card>
        </v-stepper-content>

        <!-- Course Selection -->
        <v-stepper-content step="10">
          <v-card class="mb-5" color="grey lighten-1">
            <b-row class="user-row" v-if="selected.country">
              <b-col cols="12">
                <h2 class="rebate-header">{{ current.topic.name }} – {{ current.course.name }}</h2>

                <b-row class="selected-course">
                  <b-col cols="6" sm="4" class="course-poster">
                    <img class="courseicon" fluid :src="getImgUrlExternal(current.course.icon, 'courses')" :alt="current.course.name" />
                  </b-col>

                  <b-col cols="6" sm="4" class="course-details">
                    <div class="day" v-if="selected.day != 0">
                      <p class="dayname">{{ $t("landing.day") }} {{ selected.day }}</p>
                    </div>
                    <div class="country">
                      <p class="countryname">
                        <span>{{ selected.paramcountry }}</span>
                        <span v-if="selected.state">, {{ selected.state }}</span>
                      </p>
                      <!-- <p class="countryname" v-if="selected.language == 'fr'">{{ selected.code }} – {{ selected.language.text }}</p> -->
                      <p class="countryname">{{ selected.code }} – {{ selected.paramlanguage }}</p>
                    </div>
                  </b-col>

                  <b-col cols="12" sm="4" class="start-course">
                    <b-button type="submit" tabindex="0" :to="'/' + $router.currentRoute.params.lang + '/presentation'" class="mmm-button next dropdown"
                      >{{ $t("landing.start") }}
                      <hr class="mmm-bar main-gradient" />
                      <hr class="white-bar" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </b-container>
</template>

<script>
// import {
//   getHeader,
//   uploadHeader,
//   getHeaderAuth,
//   uploadHeaderAuth
// } from '../headers.js';

import instructordatas from "../assets/instructor.json";
import { getHeader } from "../headers.js";

import { required, email } from "vuelidate/lib/validators";
import { useSessionStore } from "../session";

import { openDB } from "idb";

export default {
  props: ["userProfile"],

  data() {
    return {
      expiry: "",
      e1: 2,
      userCredentials: {
        username: "",
        password: "",
        device_name: "electron",
      },
      instructorData: [],
      userPin: "",
      internet: "off",
      error: false,
      pinerror: false,
      pinerrorMsg: "",
      viewable: false,
      showskip: false,
      errorMsg: "",
      percent: "",
      runpercent: "",
      files: "",
      serveurl: "",
      extractionid: "",
      filecount: 0,
      filenumber: 0,
      progress: 0,
      loggedin: false,
      showmanage: true,
      pinin: false,
      updatecheck: false,
      runupdate: false,
      optionstep: 6,
      daycount: [
        {
          value: "",
          text: "",
        },
      ],
      languages: [
        {
          value: "",
          text: "",
        },
      ],
      countries: [
        {
          value: "",
          text: "",
        },
      ],
      province: null,
      duration: null,
      country: null,
      provinces: {},
      durations: {},
      countires: {},
      language: null,
      // languages: [
      //   { text: "English", value: "en" },
      //   { text: "French", value: "fr" },
      // ],
      instructor: {},
      current: {
        topic: {
          name: "",
          icon: "",
          id: "",
          courses: [
            {
              id: "",
              icon: "",
              name: "",
              certdate: "",
              options: [
                {
                  id: "",
                  course_id: "",
                  code: "",
                  day: "",
                  country: "",
                  states: "",
                  language: "",
                  active: "",
                  presentation: {
                    id: "",
                    option_id: "",
                    filename: "",
                    fivepoint_status: "",
                    activated: "",
                  },
                },
              ],
            },
          ],
        },
      },
      selected: {
        topicid: "",
        courseid: "",
        presid: "",
        code: "",
        day: "",
        country: "",
        state: "",
        language: "",
        filename: "",
        paramduration: "",
        paramcountry: "",
        paramlanguage: "",
      },
    };
  },
  validations: {
    userCredentials: {
      username: {
        required,
        email,
      },
      password: {
        required,
      },
    },
    userPin: {
      required,
    },
  },

  methods: {
    // async loadInstructorData() {
    //   try {
    //     const db = await openDB("my-db", 3, {
    //       upgrade(db) {
    //         if (!db.objectStoreNames.contains("instructors")) {
    //           db.createObjectStore("instructors");
    //         }
    //       },
    //     });

    //     const data = await db.get("instructors", "current");

    //     if (data && data.data) {
    //       this.instructorData = data.data;
    //     } else {
    //       console.log("No data found in indexedDB");
    //     }
    //   } catch (error) {
    //     console.error("Error loading instructor data from indexedDB:", error);
    //   }
    // },

    step2: function () {
      //PIN LOCK SCREEN
      let vm = this;
      this.sessionStore.loadInstructor().then((data) => {
        if (vm.userPin == data.data.instructorid) {
          vm.pinerror = false;
          vm.e1 = 3;
          vm.pinin = true;
        } else {
          vm.pinerror = true;
          vm.pinerrorMsg = "Your ID does not match. Please try again.";
        }
      });
    },
    step3: function () {
      //PIN LOCK SCREEN
      let vm = this;
      vm.e1 = 4;
    },
    step4: function (topic) {
      //CHOOSE A TOPIC
      let vm = this;
      vm.current.topic = topic;
      vm.selected.topicid = topic.id;
      vm.e1 = 5;
      console.log(vm.selected);
    },
    step5: function (course) {
      //CHOOSE A COURSE

      let vm = this;
      vm.current.course = course;
      vm.selected.courseid = course.id;
      vm.selected.day = null;
      vm.selected.country = null;
      vm.selected.language = null;

      //CHECK TO MOVE TO COUNTRY STEP OR NOT

      const entries = Object.values(vm.current.course.options).filter(function (el) {
        return el.available == true;
      });

      vm.countries = [];
      var countrycount = entries.map((x) => x.country).filter((v, i, s) => s.indexOf(v) === i);
      var countryentry = entries.map((x) => x.paramcountry).filter((v, i, a) => a.findIndex((v2) => v.reserved === v2.reserved) === i);

      vm.countries.push({ value: null, disabled: true, text: "Please select a country" });
      countryentry.forEach((element, key) => {
        vm.countries.push({ value: element.reserved, text: element.name });
      });

      if (countrycount.length > 1) {
        vm.e1 = 6;
        vm.optionstep = 6;
        //selectday function has captured to day option
      } else {
        vm.selected.country = countrycount[0];
        vm.step6();
      }
      // console.log(vm.selected);
    },

    step6: function () {
      //CHOOSE A COUNTRY (IF APPLICABLE)
      let vm = this;
      vm.province = null;
      //CHECK TO MOVE TO STATE OR NOT

      const entries = Object.values(vm.current.course.options).filter(function (el) {
        return el.available == true && el.country == vm.selected.country;
      });

      let statecount = vm.stateFilter(entries);
      let statearray = [];
      statecount.forEach((element) => {
        if (element.states) {
          statearray = statearray.concat(element.states);
        }
      });
      statearray = [...new Set(statearray)];

      // console.log(statearray, statecount, entries);
      // console.log(statearray, 'statearray');

      if (statearray.length > 1) {
        vm.optionstep = 7;
        vm.provinces = statearray;
        vm.e1 = 7;
        // selectcountry function has captured the country option
      } else if (statearray.lenth === 1) {
        vm.selected.state = statearray[0];
        vm.step7();
      } else {
        vm.province = null;
        vm.selected.state = statearray[0];
        vm.step7();
      }
      // console.log(vm.selected);
    },

    step7: function () {
      //CHOOSE A STATE/PROVINCE (IF APPLICABLE)
      let vm = this;

      const entries = Object.values(vm.current.course.options).filter(function (el) {
        return el.available == true && el.country == vm.selected.country;
      });
      vm.daycount = [];

      // console.log(entries);

      //CHECK TO MOVE TO DAY STEP OR NOT
      var dayentry = entries.map((x) => x.day).filter((v, i, s) => s.indexOf(v) === i);

      vm.daycount.push({ value: null, disabled: true, text: "Please select a duration" });
      dayentry.forEach((element, key) => {
        vm.daycount.push({ value: element, text: "Day " + element });
      });

      if (dayentry.length > 1) {
        vm.e1 = 8;
        vm.optionstep = 8;
      } else {
        vm.selected.day = dayentry[0];
        vm.step8();
      }
      // console.log(vm.selected);
    },

    step8: function () {
      //CHOOSE A DAY (IF APPLICABLE)
      let vm = this;

      vm.selected.state = vm.province;
      vm.languages = [];

      if (vm.selected.country == "ca") {
        if (vm.province) {
          vm.selected.state = vm.province;
          var entries = Object.values(vm.current.course.options).filter(function (el) {
            // var found = el.states.find((element,) => element === vm.selected.state);
            // console.log(found, vm.selected.state, el, 'entries inside');

            return el.available == true && el.country == vm.selected.country && el.states.find((element) => element === vm.selected.state) == vm.selected.state;
          });

          // console.log(entries, 'this is where we need to be');
        } else {
          entries = Object.values(vm.current.course.options).filter(function (el) {
            return el.available == true && el.country == vm.selected.country;
          });
        }
      } else {
        entries = Object.values(vm.current.course.options).filter(function (el) {
          return el.available == true && el.country == vm.selected.country;
        });
      }

      let statecount = vm.stateFilter(entries);

      if (vm.selected.state && entries > 1) {
        statecount = statecount.filter((item) => {
          return item.states.includes(vm.selected.state);
        });
        var languageentry = statecount.map((x) => x.paramlanguage).filter((v, i, a) => a.findIndex((v2) => v.reserved === v2.reserved) === i);
        var languagecount = statecount.map((x) => x.language).filter((v, i, s) => s.indexOf(v) === i);
      } else {
        languageentry = entries.map((x) => x.paramlanguage).filter((v, i, a) => a.findIndex((v2) => v.reserved === v2.reserved) === i);
        languagecount = entries.map((x) => x.language).filter((v, i, s) => s.indexOf(v) === i);
      }

      vm.languages.push({ value: null, disabled: true, text: "Please select a language" });
      languageentry.forEach((element) => {
        vm.languages.push({ value: element.reserved, text: element.name });
      });

      // console.log(vm.languages, languageentry, languagecount ,vm.selected.state, entries, 'languagecount');

      if (languagecount.length > 1) {
        vm.e1 = 9;
        vm.optionstep = 9;
      } else {
        vm.language = languagecount[0];
        vm.step9();
      }

      // console.log(vm.selected);
    },

    step9: function () {
      //CHOOSE A LANGUAGE (IF APPLICABLE)
      let vm = this;
      vm.selected.language = vm.language;

      const entries = Object.values(vm.current.course.options).filter(function (el) {
        return el.available == true && el.day == vm.selected.day && el.country == vm.selected.country && el.language == vm.selected.language;
      });

      let statecount = vm.stateFilter(entries);
      let languagecount = "";

      if (vm.selected.state) {
        languagecount = statecount.filter((item) => {
          return item.language == vm.selected.language && item.states.includes(vm.selected.state);
        });
      } else {
        languagecount = statecount.filter((item) => {
          return item.language == vm.selected.language;
        });
      }

      // console.log(languagecount, vm.selected.day, vm.selected.country, vm.selected.language , vm.selected.state, vm.province, 'step9');
      if (vm.selected.country == "ca" && !vm.selected.state) {
        vm.selected.state = languagecount[0].states[0];
      }

      vm.selected.code = languagecount[0].code;
      vm.selected.filename = languagecount[0].presentation.filename;
      vm.selected.presid = languagecount[0].presentation.id;
      vm.selected.paramduration = languagecount[0].paramduration.name;
      vm.selected.paramcountry = languagecount[0].paramcountry.name;
      vm.selected.paramlanguage = languagecount[0].paramlanguage.name;

      vm.$session.set("presid", vm.selected.filename.split(".").slice(0, -1).join("."));
      vm.e1 = 10;
    },
    presentation: function () {},

    selectday: function (day) {
      let vm = this;
      vm.selected.day = day;
    },

    selectcountry: function (country) {
      let vm = this;
      vm.selected.country = country;
    },
    getImgUrl: function (imgName) {
      return require("../assets/" + imgName);

      // return require(this.api + 'uploads/topics/' + imgName );
    },

    getImgUrlExternal: function (imgName, folder) {
      // return require('../assets/'+ imgName );
      if (imgName == null) {
        return require("../assets/noimage.svg");
      }
      return "file://" + this.serveurl + "/assets/" + imgName;

      // return this.api + '/uploads/' + folder + '/' + imgName;
    },
    stateFilter: function (details) {
      let vm = this;
      let statecount = details.filter((item) => {
        return item.country == vm.selected.country;
      });
      statecount.forEach((element) => {
        if (element.states) {
          if (typeof element.states === "string" || element.states instanceof String) {
            var endorsedfor = element.states;
            var provinceArray = endorsedfor.split(",");
            element.states = provinceArray;
          }
        }
      });
      return statecount;
    },
    reroute: function () {
      this.$router.push({ path: "downloads" });
    },
    async extraction(file, location) {
      try {
        let vm = this;
        await window.file.unzip(file, location);
        vm.updatecheck = true;
        vm.runupdate = false;
      } catch (e) {
        // console.log(`Failed to unzip the file ${e}!`);
      }
    },
    async serve() {
      try {
        //     // window.file.save('public/myfile.txt', 'the text to write to the file overwrite it now!');
        let vm = this;
        let userPath = await window.file.userPath();
        vm.serveurl = userPath;
        // console.log(userPath);
        // let filepath = 'file:' + userPath + '/extractions/' + code + '.html';
        // vm.source = filepath;
      } catch (e) {
        // console.log(`Failed to serve the file ${e}!`);
      }
    },
  },

  mounted() {
    let vm = this;
    this.sessionStore = useSessionStore();

    vm.loggedin = true;
    vm.serve().then(function () {});

    if (window.navigator.onLine && vm.$root.isLoggedIn) {
      vm.showmanage = true;
      vm.internet = "on";
    } else {
      vm.showmanage = false;
    }

    this.sessionStore.loadUser().then((data) => {
      this.expiry = data.expiry;
    });

    this.sessionStore
      .loadInstructor()
      .then((data) => {
        this.instructorData = data.data;
        this.sessionStore.loadDownloads().then((downloads) => {
          for (const [key, course] of Object.entries(data.data.certifications)) {
            for (const [key, opt] of Object.entries(course.courses)) {
              for (const [key, element] of Object.entries(opt.options)) {
                if (downloads != undefined) {
                  vm.showskip = true;
                  if (this.instructorData.stackcheck) {
                    var statuscheck = data.stackcheck.options.find((c) => c.id === element.id);
                  }
                  var downloadcheck = downloads.find((c) => c.optid === element.id);
                }

                if (downloadcheck) {
                  if (statuscheck) {
                    vm.updatecheck = true;
                  }
                }
              }
            }
            // });

            for (const [key, course] of Object.entries(data.data.certifications)) {
              course.available = false;
              for (const [key, opt] of Object.entries(course.courses)) {
                opt.available = false;
                for (const [key, element] of Object.entries(opt.options)) {
                  if (downloads != undefined) {
                    var downloadcheck = downloads.find((c) => c.optid === element.id);
                  }
                  if (downloadcheck) {
                    element.available = true;
                    opt.available = true;
                    course.available = true;
                  } else {
                    element.available = false;
                  }
                }
              }
            }

            for (const [key, course] of Object.entries(data.data.storedcert)) {
              course.available = false;
              for (const [key, opt] of Object.entries(course.courses)) {
                opt.available = false;
                for (const [key, element] of Object.entries(opt.options)) {
                  if (downloads != undefined) {
                    var downloadcheck = downloads.find((c) => c.optid === element.id);
                  }
                  if (downloadcheck) {
                    element.available = true;
                    opt.available = true;
                    course.available = true;
                  } else {
                    element.available = false;
                  }
                }
              }
            }
          }
        });
      })
      .catch((error) => {
        console.error("Error loading instructor data:", error);
      });
  },
  created() {
    let vm = this;
    this.sessionStore = useSessionStore();

    // this.loadInstructorData().then(() => {
    //   vm.instructor = this.instructorData;
    // });

    this.sessionStore.loadDownloads().then((downloads) => {
      if (downloads != undefined) {
        vm.showskip = true;
      }
    });

    if (vm.$root.isLoggedIn) {
      vm.e1 = 2;
      vm.loggedin = true;
      if (vm.pinin == true) {
        vm.e1 = 3;
      }
    } else {
      this.$router.push({ path: "auth" });
    }
  },

  beforeCreate: function () {
    let vm = this;
    this.sessionStore = useSessionStore();

    this.sessionStore.loadJWT().then((data) => {
      console.log(`hwt`, data);
      if (data && data.trim() !== "") {
        console.log("JWT is present, setting isLoggedIn to true");
        vm.$root.isLoggedIn = true; // User is logged in
      } else {
        console.log("No JWT found, setting isLoggedIn to false");
        vm.$root.isLoggedIn = false; // User is not logged in
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/global.scss";

p.selectallcap {
  margin-bottom: 2px;
  text-transform: uppercase;
}
.button-cont {
  display: flex;
}
</style>
